<template>
    <span>
        <template v-if="action.actionType === 'tp-buy' && action.buyType === 'instant'">
            <b-icon icon="scale-balance" size="is-small" title="Trading Post" />
            Instantly buy {{action.count}} {{action.item.name}}
        </template>
        <template v-else-if="action.actionType === 'tp-buy' && action.buyType === 'buyorder'">
            <b-icon icon="scale-balance" size="is-small" title="Trading Post"/>
            Buy order {{action.count}} {{action.item.name}}
        </template>
        <template v-else-if="action.actionType === 'craft'">
            <template v-if="action.recipe.producedAmount !== 1">
                Craft {{action.count * action.recipe.producedAmount}} {{action.recipe.producedItem.name}} ({{action.count}} crafts)
            </template>
            <template v-else>
                Craft {{action.count * action.recipe.producedAmount}} {{action.recipe.producedItem.name}}
            </template>
        </template>
        <template v-else-if="action.actionType === 'merchant-buy'">
            <!-- TODO: A better icon -->
            <b-icon icon="cash" size="is-small" title="Merchant"/>
            Buy {{action.count * action.offer.soldAmount}} {{action.offer.soldResource.name}} from a merchant
        </template>
        <template v-else-if="action.actionType === 'double-click'">
            <!-- TODO: Write what you need to double-click -->
            <b-icon icon="cursor-default" size="is-small" title="Double-click"/>
            Create {{action.count}} {{action.doubleClick.producedResource.name}} by double-clicking
        </template>
        <template v-else>
            Unknown action
        </template>
    </span>
</template>

<script>
    export default {
        props: ['action'],
        name: "AcquisitionAction",
    }
</script>

<style scoped>

</style>